import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../../Popup/PopupV2';

import styles from './notReadyPopup.scss';
import popupStyles from '../../Popup/popupv2.scss';
import { HotelPlannerTracking } from '../../Analytics/constants';
import { trackEvent } from '../../Analytics/TrackedClick';

const NotReadyForPowerPopup = ({ onCloseClick, redirectUrl }) => {
    const hotelPlannerUrl = redirectUrl || 'https://utrsports.hotelplanner.com/';

    const modalHeader = () => {
        return (
            <div className={`${popupStyles.modalHeader} ${styles.header}`}>
                <div className={styles.headerSpacer} />
                <p className={styles.headerTitle}>
                    Power: The tennis membership that pays for itself.
                </p>
            </div>
        );
    };

    const handleOnGoToHotelPlannerClick = () => {
        trackEvent(HotelPlannerTracking.HOTEL_PLANNER_SEARCH_CLICK, {
            referringSurface: HotelPlannerTracking.NOT_READY_FOR_POWER_POPUP_SURFACE,
        });
        window.open(hotelPlannerUrl, '_blank', 'noopener,noreferrer');
        onCloseClick();
    };

    const handleOnNoThanksClick = () => {
        onCloseClick();
    };

    return (
        <div className={`${styles.popup} overlay lite-black`}>
            <Popup
                className="popup-lg"
                config={{
                    size: 'lg',
                    scrollable: true,
                    customHeader: modalHeader,
                    bodyClassName: styles.modalBodyMobile,
                }}
                onCloseClick={onCloseClick}
            >
                <div className={styles.container}>
                    <p className={styles.title}>Not Ready for Power?</p>
                    <p className={styles.subtitle}>Search hotels at regular Hotel Planner rates.</p>
                    <button
                        type="button"
                        className={`btn btn-primary btn-small text-uppercase ${styles.button}`}
                        onClick={handleOnGoToHotelPlannerClick}
                        data-testid="modal.not-ready-for-power.hotel-planner-btn"
                    >
                        Go to Hotel Planner
                    </button>
                    <button
                        type="button"
                        className={`btn btn-default btn-small text-uppercase mt8 ${styles.button}`}
                        onClick={handleOnNoThanksClick}
                        data-testid="modal.not-ready-for-power.no-thanks-btn"
                    >
                        No Thanks
                    </button>
                </div>
            </Popup>
        </div>
    );
};

NotReadyForPowerPopup.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    redirectUrl: PropTypes.string.isRequired,
};

export default NotReadyForPowerPopup;
